import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import MainComponent from "../../MainComponent.js";
import "bootstrap/dist/css/bootstrap.min.css";
import Select from "react-select";
import { getRandomColor, createImageFromInitials } from "../../Utils";
import "./BIDetails.css";
import { url } from "../../../store/sagas/API.js";
import {
  biDetails,
  biDetailsPost,
  bisubsectorGet,
  postBiRolePermissions,
  postLocalFolderManager,
  biUserManagementGet,
  biUserManagementPost,
  biUserManagementDelete,
} from "../../../store/actions/index.js";
import OtherImage from "../../../assets/images/Othericon.svg";
import HelpInfo from "../../../utils/helpInfoProviderComponent.js";
import keys from "../../../utils/helpInfoKeys.json";
import SideNavHelpInfo from "../../../utils/SideNavHelpInfo.js";
import Breadcrumb from "../../Breadcrumb.js";
import CommentSection from "../../../utils/CommentSection.js";
import Login from "../../Login.js";
import UploadFiles from "../../UploadFiles.js";
import { motion, time } from "motion/react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { SlCalender } from "react-icons/sl";
import { AiOutlineSearch } from "react-icons/ai";
import Drawer from "@mui/material/Drawer";
import Alert from "../../Alert.js";
function BIDetails() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ls_bi_id = localStorage.getItem("bi_id");
  const isBISubmitted = useSelector((state) => state.isBISubmitted);
  const isBIGetFetched = useSelector((state) => state.isBIGetFetched);
  const biDetailsPostSucess = useSelector((state) => state.biDetailsPostSucess);
  const biDetailsGetSuccess = useSelector((state) => state.biDetailsGetSuccess);
  const selectedPermission = useSelector((state) => state.selectedPermission);
  const [isClicked, setIsClicked] = useState(false);
  const [biSectorData, setBiSectorData] = useState([]);
  const [biSubSectorData, setBiSubSectorData] = useState([]);
  const isSectorChanged = useSelector((state) => state.isSectorChanged);
  const [selectedOption, setSelectedOption] = useState([]);
  const [selectedSector, setSelectedSector] = useState("");
  const [selectedSubSector, setSelectedSubSector] = useState([]);
  const [emp_data, setEmpData] = useState([]);
  const [sectorChange, setSectorChange] = useState(false);
  const [biObjective, setBIObjective] = useState("");
  const [biDescription, setBIDescription] = useState("");
  const [biName, setBIName] = useState("");
  const [biStartDate, setBIStartDate] = useState("");
  const [biTargetDate, setBITargetDate] = useState("");
  const [excelrateLead, setExcelrateLead] = useState("");
  const [bIBelongsToData, setBIBelongsToData] = useState([]);
  const [selectedBiBelongsTo, setSelectedBiBelongsTo] = useState(null);
  const uploadFilesRef = useRef(null);
  const [disableNext, setDisableNext] = useState(false);
  const [showUploadComp, setShowUploadComp] = useState(false);
  const [biUsers, setBiUsers] = useState([]);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [nonBiUsers, setNonBiUsers] = useState([]);
  const [selectedNonBiUsers, setSelectedNonBiUsers] = useState([]);
  const [biUsersSearch, setBiUsersSearch] = useState("");
  const [sidebarUsersSearch, setSidebarUsersSearch] = useState("");
  const biUserManagementGetData = useSelector((state) => state.biUserManagementGetData);
  const biUserManagementPostData = useSelector((state) => state.biUserManagementPostData);
  const biUserManagementDeleteData = useSelector((state) => state.biUserManagementDeleteData);

  const filteredBiUsers = biUsers.filter((user) =>
    user.employee_name.toLowerCase().includes(biUsersSearch.toLowerCase())
  );
  const filteredNonBiUsers = nonBiUsers.filter((user) =>
    user.employee_name.toLowerCase().includes(sidebarUsersSearch.toLowerCase())
  );

  const userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
  const currentUserEmpId = userDetails?.data?.emp_id;

  const uiListDetails = useSelector((state) => state.uiListDetails);

  const isBISubSectorFetched = useSelector(
    (state) => state.isBISubSectorFetched
  );
  const biSubSectorGetDetails = useSelector(
    (state) => state.biSubSectorGetDetails
  );
  const fetchpostLocalManagerData = useSelector(
    (state) => state.fetchpostLocalManagerData
  );
  const selectedNewBI = useSelector((state) => state.selectedNewBI);
  const selectedHelpInfoSidebar = useSelector(
    (state) => state.selectedHelpInfoSidebar
  );
  useEffect(() => {
    if (selectedNewBI === false) {
      setSelectedOption([]);
      setBIObjective("");
      setBIDescription("");
      setBIName("");
      setSelectedSector("");
      setSelectedSubSector([]);
      setBIStartDate("");
      setBITargetDate("");
      setExcelrateLead("");
      setSelectedBiBelongsTo("");
    }
  }, [selectedNewBI]);

  const BIcustomStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      display: "inline-block",
      border: "1px solid #ccc",
      boxSizing: "border-box",
      paddingLeft: 0,
      borderRadius: "10px",
    }),
    img: {
      height: 40,
    },
  };
  useEffect(() => {
    dispatch(biDetails(localStorage.getItem("bi_id")));
    localStorage.removeItem("product_id");
    return () => {};
  }, [biDetailsPostSucess]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === "s") {
        event.preventDefault();
        document.querySelector(".bidetails-form")?.requestSubmit();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const [createNewBi, setCreateNewBi] = useState(false);
  

  useEffect(() => {
  
    if (uiListDetails) {
        if (uiListDetails.data) {
          if (uiListDetails.data.message) {
            const data = uiListDetails.data.message[0].filter(
              (each) => each.title === "Dashboard"
            );
            const isdisabled =
              data.length > 0 ? !data[0].disable_new_bi_button : false;
            setCreateNewBi(isdisabled)
          }
        }
      }

  }, [uiListDetails]);

  useEffect(() => {
    if (isBIGetFetched) {
      if (biDetailsGetSuccess) {
        if (biDetailsGetSuccess.ok) {
          if (localStorage.getItem("bi_id")) {
            if (biDetailsGetSuccess.data.bi_data) {
              setBIName(biDetailsGetSuccess.data.bi_data[0].bi_name);
              setExcelrateLead(
                biDetailsGetSuccess.data.bi_data[0].excel_lead_name
              );
              setBIObjective(biDetailsGetSuccess.data.bi_data[0].objective);
              setBIDescription(biDetailsGetSuccess.data.bi_data[0].description);
              setBIStartDate(
                biDetailsGetSuccess.data.bi_data[0].start_date
                  ? biDetailsGetSuccess.data.bi_data[0].start_date.split(" ")[0]
                  : ""
              );
              setBITargetDate(
                biDetailsGetSuccess.data.bi_data[0].target_date
                  ? biDetailsGetSuccess.data.bi_data[0].target_date.split(
                      " "
                    )[0]
                  : ""
              );
            }
          }
          if (biDetailsGetSuccess.data.mst_sec) {
            let selectedSectors = [];
            setBiSectorData(
              biDetailsGetSuccess.data.mst_sec.map((obj) => {
                if (obj.isselected === "true") {
                  selectedSectors.push({
                    value: obj.id,
                    label: obj.prop_name,
                    icon: obj.icon ? url + obj.icon : OtherImage,
                  });
                }
                return {
                  value: obj.id,
                  label: obj.prop_name,
                  icon: obj.icon ? url + obj.icon : OtherImage,
                };
              })
            );
            setSelectedSector(selectedSectors);
          }
          if (biDetailsGetSuccess.data.sub_sec) {
            let selectedSubSectors = [];
            setBiSubSectorData(
              biDetailsGetSuccess.data.sub_sec.map((obj, i) => {
                if (obj.isselected === "true") {
                  selectedSubSectors.push({
                    value: obj.id,
                    label: obj.prop_name,
                    parent: obj.sec_name,
                    icon: obj.icon ? url + obj.icon : OtherImage,
                  });
                }
                return {
                  value: obj.id,
                  label: obj.prop_name,
                  parent: obj.sec_name,
                  icon: obj.icon ? url + obj.icon : OtherImage,
                };
              })
            );
            setSelectedSubSector(selectedSubSectors);
          }
          if (biDetailsGetSuccess.data.bi_belongs_to) {
            let selected_bi_belongs_to = [];
            setBIBelongsToData(
              biDetailsGetSuccess.data.bi_belongs_to.map((obj) => {
                if (obj.isselected === "true") {
                  selected_bi_belongs_to.push({
                    value: obj.id,
                    label: obj.prop_name,
                    icon: obj.icon ? url + obj.icon : OtherImage,
                  });
                }
                return {
                  value: obj.id,
                  label: obj.prop_name,
                  icon: obj.icon ? url + obj.icon : OtherImage,
                };
              })
            );
            setSelectedBiBelongsTo(selected_bi_belongs_to[0]);
          }
          if (biDetailsGetSuccess.data.emp_data) {
            setEmpData(
              biDetailsGetSuccess.data.emp_data.map((obj) => {
                if (obj.isselected === "true") {
                  setSelectedOption({
                    value: obj.id,
                    label: obj.prop_name,
                    icon: createImageFromInitials(
                      30,
                      obj.prop_name,
                      getRandomColor(obj.prop_name)
                    ),
                  });
                }
                return {
                  value: obj.id,
                  label: obj.prop_name,
                  icon: createImageFromInitials(
                    30,
                    obj.prop_name,
                    getRandomColor(obj.prop_name)
                  ),
                };
              })
            );
          }
          if (biDetailsGetSuccess.data.bi_users) {
            setBiUsers(biDetailsGetSuccess.data.bi_users);
          }
        }
      }
    }
    return () => {};
  }, [biDetailsGetSuccess]);
  useEffect(() => {
    if (isBISubSectorFetched) {
      if (biSubSectorGetDetails) {
        if (biSubSectorGetDetails.ok) {
          let selectedSubSectors = [];
          setBiSubSectorData(
            biSubSectorGetDetails.data.data.map((obj, i) => {
              if (selectedSubSector?.some((sub) => obj.id === sub.value)) {
                selectedSubSectors.push({
                  value: obj.id,
                  label: obj.prop_name,
                  parent: obj.sec_name,
                  icon: obj.icon ? url + obj.icon : OtherImage,
                });
              }
              return {
                value: obj.id,
                label: obj.prop_name,
                parent: obj.sec_name,
                icon: obj.icon ? url + obj.icon : OtherImage,
              };
            })
          );
          setSelectedSubSector(selectedSubSectors);
        } else {
          console.log(biSubSectorGetDetails.data);
        }
      } else {
        console.log("Not able to fetch the data");
      }
    }
  }, [isSectorChanged, isBISubSectorFetched]);

  // Handle get non-BI users response
  useEffect(() => {
    if (biUserManagementGetData) {
      if (biUserManagementGetData.ok) {
        if (biUserManagementGetData.data.non_bi_users) {
          setNonBiUsers(biUserManagementGetData.data.non_bi_users);
        }
      }
    }
  }, [biUserManagementGetData]);

  // Handle add users response
  useEffect(() => {
    if (biUserManagementPostData) {
      if (biUserManagementPostData.ok) {
        setShowAddUserModal(false);
        setSelectedNonBiUsers([]);
        setNonBiUsers([]);
        // Refresh the BI details to get updated users list
        dispatch(biDetails(localStorage.getItem("bi_id")));
      }
    }
  }, [biUserManagementPostData]);

  // Handle delete users response
  useEffect(() => {
    if (biUserManagementDeleteData) {
      if (biUserManagementDeleteData.ok) {
        // Refresh the BI details to get updated users list
        dispatch(biDetails(localStorage.getItem("bi_id")));
      }
    }
  }, [biUserManagementDeleteData]);

  const handleOpenAddUserModal = () => {
    const bi_id = localStorage.getItem("bi_id");
    if (bi_id) {
      dispatch(biUserManagementGet(bi_id));
      setShowAddUserModal(true);
    }
  };

  const handleCloseAddUserModal = () => {
    
    setShowAddUserModal(false);
    setTimeout(() => {
      setSelectedNonBiUsers([]);
      setNonBiUsers([]);
  }, 300);

  };

  const handleToggleUserSelection = (userId) => {
    setSelectedNonBiUsers((prev) => {
      if (prev.includes(userId)) {
        return prev.filter((id) => id !== userId);
      } else {
        return [...prev, userId];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedNonBiUsers.length === nonBiUsers.length) {
      setSelectedNonBiUsers([]);
    } else {
      setSelectedNonBiUsers(nonBiUsers.map((user) => user.name));
    }
  };

  const handleAddUsers = () => {
    const bi_id = localStorage.getItem("bi_id");
    if (bi_id && selectedNonBiUsers.length > 0) {
      dispatch(biUserManagementPost(bi_id, selectedNonBiUsers));
    }
  };

  const handleDeleteUser = (emp_id, employee_name) => {
    const bi_id = localStorage.getItem("bi_id");
    if (bi_id && emp_id) {
      Alert.warning({
          title: "Confirm Removal",
          html: `Do you want to remove <span style="font-weight:600;">${employee_name}</span> from this Business Initiative?`,
          confirmButtonText: "Remove",
          icon: "warning",
          showConfirmButton: true,
          showCancelButton: true,
          preConfirm: (isConfirm) => {
            if (isConfirm) {
              dispatch(biUserManagementDelete(bi_id, emp_id));
            } else {
            }
          },
        });
      
    }
  };

  const SendData = (e) => {
    e.preventDefault();
    if (selectedPermission === "write" || selectedPermission === "admin") {
      dispatch(
        biDetailsPost(
          localStorage.getItem("bi_id"),
          e.target.giname.value,
          e.target.emp_id.value,
          selectedSector,
          selectedSubSector,
          e.target.obj.value,
          e.target.desc.value || "",
          biStartDate,
          biTargetDate,
          selectedBiBelongsTo.value
        )
      );
      setIsClicked(true);
    }
  };

  useEffect(() => {
    if (isBISubmitted && isClicked) {
      if (biDetailsPostSucess) {
        if (biDetailsPostSucess.ok) {
          setShowUploadComp(true);
          if (localStorage.getItem("bi_id")) {
          } else {
            localStorage.setItem("bi_id", biDetailsPostSucess.data.bi_id);
            dispatch(postBiRolePermissions(biDetailsPostSucess.data.bi_id, window.location.href));
            console.log("bi_id")
            if (!ls_bi_id) {
              setDisableNext(true);
            }
          }
        }
      }
    }
  }, [isBISubmitted]);
  useEffect(() => {
  if (biDetailsPostSucess?.ok && isClicked)  {
    // Smooth scroll to the upload section
    setTimeout(() => {
      uploadFilesRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 500);
  }
}, [ biDetailsPostSucess]);
  const handleSelect = (e) => {
    const selectedValues = e.map((option) => option.value);
    setSelectedSector(e);
    setSectorChange(!sectorChange);
    // setSelectedSubSector(null);
    const data = {
      bi_id: localStorage.getItem("bi_id") || null,
      sec_name: selectedValues,
    };
    dispatch(bisubsectorGet(data, sectorChange));
  };

  // handle onChange event of the dropdown
  const handleChange = (e) => {
    setSelectedOption(e);
  };
  const handleSubSectorSelect = (e) => {
    setSelectedSubSector(e);
  };
  const handleBackButton = () => {
    navigate("/dashboard", { replace: true });
    localStorage.setItem("newbuttonClicked", JSON.stringify(false));
  };
  const handleNextButton = () => {
    navigate("/biproductdetails", { replace: true });
    window.location.reload();
  };
  const handleBiBusinessTypeSelect = (e) => {
    setSelectedBiBelongsTo(e);
  };

  const customFilter = (option, searchText) => {
    if (option.data.label.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      display: "inline-block",
      border: "1px solid #ccc",
      boxSizing: "border-box",
      // paddingLeft: 0,
      padding: "6px 0px 0px 0px",
      borderRadius: "10px",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      fontSize: "var(--text-font-size)", // Adjust the font size as needed
    }),
    img: {
      height: 20,
    },
    multiValue: (styles, { data }) => {
    
    return {
      ...styles,
      borderRadius: "6px",
      backgroundColor: "#eff4f5",
      border: "1px solid #d4dbd7",
    };
    },
  };

  var content = (
    <>
      <div
        style={{
          position: "absolute",
          top: "80px",
          backgroundColor: "white",
          width: "100%",
          zIndex: "1",
        }}
      >
        <Breadcrumb
          // SecondSideBarClicked={(value) => setIsSecSideBarOpen(value)}
          // isSecSideBarOpen={isSecSideBarOpen}
          breadcrumbItems={[
            {
              text: "Onboarding",
            },
            {
              text: "BI Details",
            },
            {
              text: undefined,
            },
          ]}
        />
      </div>
      <div className="bidetails-main-container">
      <Form className="bidetails-form" onSubmit={SendData} style={{ width: "65%" }} >
        <div>
          <motion.div
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.8 }}
            style={{
              display: "flex",
              flexDirection: "column",
              "&::WebkitScrollbar": { display: "none" },
              fontSize: "var(--sub-heading-font-size)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontSize: "var(--main-heading)",
                  fontWeight: "var(--heading-font-weight)",
                  marginRight: "5px",
                }}
              >
                Tell us about your Business Initiative
              </div>
            </div>
            <br />
            <div style={{ alignItems: "center" }}>
              <Form.Group className="bidetails-input-container">
                <Form.Label className="bi_details-title">
                  Business Initiative Name<span className="required">*</span>
                  <HelpInfo
                    documentName={"BI Details"}
                    helpKey={keys["BI Details"].Name}
                    image={"flashy"}
                  />
                </Form.Label>
                <Form.Control
                  name="giname"
                  type="text"
                  placeholder="e.g. Marketing Plan"
                  value={biName}
                  onChange={(e) => setBIName(e.target.value.slice(0, 40))}
                  required
                  style={{
                    borderRadius: 10,
                    fontSize: "var(--text-font-size)",
                  }}
                  autoComplete="off"
                  disabled={
                    selectedPermission === "write" ||
                    selectedPermission === "admin"
                      ? false
                      : true
                  }
                />
              </Form.Group>
            </div>

            <div style={{ display: "flex", marginTop: "10px" }}>
              <Form.Group className="bidetails-input-container">
                <Form.Label className="bi_details-title">
                  Owner of Business Initiative
                  <span className="required">*</span>
                  {/* <HelpInfo
                    documentName={"BI Details"}
                    helpKey={keys["BI Details"].Owner}
                  /> */}
                </Form.Label>
                <Select
                  required
                  name="emp_id"
                  styles={{
                          ...customStyles,
                          control: (provided, state) => ({
                            ...customStyles.control?.(provided, state),
                            padding: 0,
                          }),
                        }}
                  className="form-control selectr"
                  placeholder="Assign owner to Business Initiative"
                  value={selectedOption}
                  options={emp_data}
                  onChange={handleChange}
                  isSearchable={true}
                  filterOption={customFilter}
                  getOptionLabel={(e) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img alt="" src={e.icon} />
                      <span
                        style={{
                          marginLeft: 5,
                          fontSize: "var(--text-font-size)",
                        }}
                      >
                        {e.label}
                      </span>
                    </div>
                  )}
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                    // Option: EmpIconOption,
                  }}
                  isDisabled={
                    selectedPermission === "write" ||
                    selectedPermission === "admin"
                      ? false
                      : true
                  }
                />
              </Form.Group>
              {/* <Form.Group className="bidetails-select-sec-container">
                <Form.Label className="bi_details-title">
                  Excelrate Lead{" "}
                  <HelpInfo
                    documentName={"BI Details"}
                    helpKey={keys["BI Details"].XLLead}
                  />
                </Form.Label>
                <Form.Control
                  name="leadname"
                  type="text"
                  placeholder="Excelrate Lead Name"
                  value={excelrateLead}
                  onChange={(e) => setExcelrateLead(e.target.value)}
                  required
                  style={{
                    borderRadius: 10,
                    height: "38px",
                    fontSize: "var(--text-font-size)",
                  }}
                  disabled
                />
              </Form.Group> */}
            </div>
            <div className="bidetails-input-container">
              <Form.Group>
                <Form.Label className="bi_details-title">
                  Sector to which your Business Initiative belongs to
                  <span className="required">*</span>
                </Form.Label>
                <Select
                  required
                  name="selectedbitype"
                  styles={BIcustomStyles}
                  className="form-control selectr"
                  placeholder="Sector to which your business initiative belongs to"
                  value={selectedBiBelongsTo}
                  options={bIBelongsToData}
                  onChange={handleBiBusinessTypeSelect}
                  isSearchable={true}
                  filterOption={customFilter}
                  getOptionLabel={(e) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img alt="" style={{ height: 30 }} src={e.icon} />
                      <span
                        style={{
                          marginLeft: 5,
                          fontSize: "var(--text-font-size)",
                        }}
                      >
                        {e.label}
                      </span>
                    </div>
                  )}
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                    // Option: IconOption,
                  }}
                  isDisabled={
                    selectedPermission === "write" ||
                    selectedPermission === "admin"
                      ? false
                      : true
                  }
                />
              </Form.Group>
            </div>
            <div style={{ display: "flex" }}>
              <Form.Group className="bidetails-select-container">
                <Form.Label className="bi_details-title">
                  Target Sectors<span className="required">*</span>
                  <HelpInfo
                    documentName={"BI Details"}
                    helpKey={keys["BI Details"].Sector}
                    image={"flashy"}
                  />
                </Form.Label>
                <Select
                  required
                  isMulti
                  name="sector"
                  styles={customStyles}
                  className="form-control selectr"
                  placeholder="Select Sector"
                  value={selectedSector}
                  options={biSectorData}
                  onChange={handleSelect}
                  isSearchable={true}
                  filterOption={customFilter}
                  getOptionLabel={(e) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img alt="" style={{ height: 24 }} src={e.icon} />
                      <span
                        style={{
                          marginLeft: 5,
                          fontSize: "var(--text-font-size)",
                        }}
                      >
                        {e.label}
                      </span>
                    </div>
                  )}
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                    // Option: IconOption,
                  }}
                  isDisabled={
                    selectedPermission === "write" ||
                    selectedPermission === "admin"
                      ? false
                      : true
                  }
                />
              </Form.Group>
              <Form.Group className="bidetails-select-sec-container">
                <Form.Label className="bi_details-title">
                  Target Sub Sectors<span className="required">*</span>
                  <HelpInfo
                    documentName={"BI Details"}
                    helpKey={keys["BI Details"].SubSector}
                    image={"flashy"}
                  />
                </Form.Label>
                <Select
                  required
                  isMulti
                  name="subsector"
                  styles={customStyles}
                  className="form-control selectr"
                  placeholder="Select Sub Sector"
                  value={selectedSubSector}
                  options={biSubSectorData}
                  onChange={handleSubSectorSelect}
                  isSearchable={true}
                  filterOption={customFilter}
                  getOptionLabel={(e) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img alt="" style={{ height: 24 }} src={e.icon} />
                      <span
                        style={{
                          marginLeft: 5,
                          fontSize: "var(--text-font-size)",
                        }}
                      >
                        {e.label}
                      </span>
                    </div>
                  )}
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                    // Option: IconOption,
                  }}
                  isDisabled={
                    selectedPermission === "write" ||
                    selectedPermission === "admin"
                      ? false
                      : true
                  }
                />
              </Form.Group>
            </div>

            <div>
              <Form.Group className="bidetails-input-container">
                <Form.Label className="bi_details-title">
                  Objective<span className="required">*</span>
                  <HelpInfo
                    documentName={"BI Details"}
                    helpKey={keys["BI Details"].Objective}
                    image={"flashy"}
                  />
                </Form.Label>
                <Form.Control
                  name="obj"
                  as="textarea"
                  rows={3}
                  placeholder="Write an Objective"
                  required
                  value={biObjective}
                  onChange={(e) => setBIObjective(e.target.value)}
                  style={{
                    borderRadius: 10,
                    fontSize: "var(--text-font-size)",
                  }}
                  autoComplete="off"
                  disabled={
                    selectedPermission === "write" ||
                    selectedPermission === "admin"
                      ? false
                      : true
                  }
                />
              </Form.Group>
            </div>
            <div>
              <Form.Group className="bidetails-input-container">
                <Form.Label className="bi_details-title">
                  Description<span className="required">*</span>
                  <HelpInfo
                    documentName={"BI Details"}
                    helpKey={keys["BI Details"].Description}
                  />
                </Form.Label>
                <Form.Control
                  name="desc"
                  as="textarea"
                  rows={3}
                  placeholder="Write a short Description about the Business Initiative"
                  required
                  value={biDescription}
                  onChange={(e) => setBIDescription(e.target.value)}
                  style={{
                    borderRadius: 10,
                    fontSize: "var(--text-font-size)",
                  }}
                  autoComplete="off"
                  disabled={
                    selectedPermission === "write" ||
                    selectedPermission === "admin"
                      ? false
                      : true
                  }
                />
              </Form.Group>
            </div>
            <div style={{ display: "flex" }}>
              <Form.Group className="bidetails-select-container">
                <Form.Label className="bi_details-title">
                  <span>Start Date(Optional)</span>
                </Form.Label>
                <div className="w-100 position-relative">
                  {/* Start Date Picker */}
                  <DatePicker
                    wrapperClassName="w-100"
                    selected={biStartDate ? new Date(biStartDate) : null}
                    onChange={(d) => setBIStartDate(d ? new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().split("T")[0] : "")}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    dateFormat="yyyy-MM-dd"
                    placeholderText="YYYY-MM-DD"
                    customInput={
                      <input
                        className="form-control"
                        style={{
                          width: "100%",
                          borderRadius: 10,
                          fontSize: "var(--text-font-size)",
                        }}
                        readOnly
                      />
                    }
                    disabled={
                      selectedPermission === "write" || selectedPermission === "admin"
                        ? false
                        : true
                    }
                  />
                  <SlCalender
                    size={14}
                    color={biStartDate ? "#28a745" : "gray"}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none"
                    }}
                  />
                </div>
              </Form.Group>
              <Form.Group className="bidetails-select-sec-container">
                <Form.Label className="bi_details-title">
                  Target Date(Optional)
                </Form.Label>
                <div className="w-100 position-relative">
                  {/* Start Date Picker */}
                  <DatePicker
                    wrapperClassName="w-100"
                    selected={biTargetDate ? new Date(biTargetDate) : null}
                    onChange={(d) => setBITargetDate(d ? new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().split("T")[0] : "")}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    dateFormat="yyyy-MM-dd"
                    placeholderText="YYYY-MM-DD"
                    // Using the plain HTML input element format that works perfectly
                    customInput={
                      <input
                        className="form-control"
                        style={{
                          width: "100%",
                          borderRadius: 10,
                          fontSize: "var(--text-font-size)",
                        }}
                        readOnly
                      />
                    }
                    disabled={
                      selectedPermission === "write" || selectedPermission === "admin"
                        ? false
                        : true
                    }
                  />
                  <SlCalender
                    size={14}
                    color={biTargetDate ? "#28a745" : "gray"}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none"
                    }}
                  />
                </div>

              </Form.Group>
            </div>
            {showUploadComp && !ls_bi_id && (
              <Form.Label
                className="bi_details-title"
                style={{ marginTop: "10px" }}
              >
                <span>Please upload strategy related documents</span>
              </Form.Label>
            )}
            {ls_bi_id && (
              <Form.Label
                className="bi_details-title"
                style={{ marginTop: "10px" }}
              >
                <span>Please upload strategy related documents</span>
              </Form.Label>
            )}
            {showUploadComp && !ls_bi_id && (
              <div className="bidetails-upload-container" ref={uploadFilesRef}>
                <UploadFiles selectedSubMenuPermission={selectedPermission} />
              </div>
            )}
            {ls_bi_id && (
              <div className="bidetails-upload-container" ref={uploadFilesRef}>
                <UploadFiles selectedSubMenuPermission={selectedPermission} />
              </div>
            )}
            {ls_bi_id && <CommentSection />}
            {selectedHelpInfoSidebar && <SideNavHelpInfo />}
          </motion.div>
          <div
            className="main-footer"
            style={{
              display: "flex",
              alignItems: "center",
              float: "right",
              position: "absolute",
              top: "70px",
              right: "0px",
              zIndex: 2,
            }}
          >
            <Button
              type="submit"
              className="save-button-style-bidetails"
              disabled={
                selectedPermission === "write" || selectedPermission === "admin"
                  ? false
                  : true
              }
            >
              Save
            </Button>
            <Button onClick={handleBackButton} className="back-button-style">
              Back
            </Button>
            <Button
              onClick={handleNextButton}
              className="next-button-style"
              disabled={!disableNext && !ls_bi_id}
            >
              Next
            </Button>
            <span style={{ paddingLeft: "20px" }}>
              <HelpInfo
                documentName={"BI Details"}
                helpKey={keys["BI Details"].BiInfo}
                image={"question"}
              />
            </span>
          </div>
        </div>
      </Form>
      <motion.div
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.8 }}
            style={{
              width: "35%",
            }}
          >
      <div className="user-container">
        <div className="user-container-header">
          <div className="user-container-title">BI Users</div>
          {ls_bi_id && (selectedPermission === "write" || selectedPermission === "admin") && (
            <button className="add-user-btn" onClick={handleOpenAddUserModal}>+ Add Users</button>
          )}
        </div>
        {biUsers.length > 0 && (
          <div className="user-search-wrapper">
            <AiOutlineSearch className="user-search-icon" />
            <input
              type="text"
              className="user-search-input"
              placeholder="Search users..."
              value={biUsersSearch}
              onChange={(e) => setBiUsersSearch(e.target.value)}
            />
          </div>
        )}
        <div className="user-list">
          {filteredBiUsers.length > 0 ? (
            filteredBiUsers.map((user, index) => (
              <div key={index} className="user-item">
                <img
                  alt=""
                  src={
                    user.image
                      ? url + user.image
                      : createImageFromInitials(
                          35,
                          user.employee_name,
                          getRandomColor(user.employee_name)
                        )
                  }
                  className="user-avatar"
                />
                <div className="user-info">
                  <span className="user-name">{user.employee_name}</span>
                </div>
                
                {(selectedPermission === "write" || selectedPermission === "admin") && 
                user.name !== currentUserEmpId &&
                <button
                  className="user-delete-btn"
                  title="Remove user"
                  onClick={() => handleDeleteUser(user.name, user.employee_name)}
            
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
                  </svg>
                </button>}
              </div>
            ))
          ) : biUsers.length > 0 ? (
            <div className="user-empty">No users found</div>
          ) : (
            <div className="user-empty">No users added yet</div>
          )}
        </div>
      </div>
      </motion.div>

      <Drawer
        sx={{
          "& .MuiDrawer-paper": {
            width: "50%",
            marginTop: "64px",
            height: "calc(100% - 64px)", // keep paper ending at viewport bottom (MUI sets top:0/height:100%)
            display: "flex",
            flexDirection: "column",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "transparent",
            },
          },
        }}
        PaperProps={{
          sx: {
            boxShadow: "none",
            borderLeft: "1px solid lightGray",
          },
        }}
        anchor="right"
        transitionDuration={{ enter: 500, exit: 300 }}
        SlideProps={{
          easing: {
            enter: "cubic-bezier(0.0, 0, 0.2, 1)",
            exit: "cubic-bezier(0.4, 0.0, 1, 1)",
          },
        }}
        open={showAddUserModal}
        onClose={handleCloseAddUserModal}
      >
        <div className="add-user-sidebar-header">
          
          <h3>Add Users</h3>
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <button
            className="sidebar-add-btn"
            onClick={handleAddUsers}
            disabled={selectedNonBiUsers.length === 0}
          >
            Add ({selectedNonBiUsers.length})
          </button>
          
          
          <button className="sidebar-close-btn" onClick={handleCloseAddUserModal}>&times;</button>
          </div>
        </div>
        <div className="add-user-sidebar-body">
          {nonBiUsers.length > 0 ? (
            <>
              <div className="user-search-wrapper">
                <AiOutlineSearch className="user-search-icon" />
                <input
                  type="text"
                  className="user-search-input"
                  placeholder="Search users..."
                  value={sidebarUsersSearch}
                  onChange={(e) => setSidebarUsersSearch(e.target.value)}
                  style={{ marginBottom: "10px" }}
                />
              </div>
              <div className="select-all-item" onClick={handleSelectAll}>
                <input
                  type="checkbox"
                  className="user-checkbox"
                  checked={nonBiUsers.length > 0 && selectedNonBiUsers.length === nonBiUsers.length}
                  onChange={handleSelectAll}
                />
                <span className="select-all-label">Select All</span>
                <span className="select-all-count">({selectedNonBiUsers.length}/{nonBiUsers.length})</span>
              </div>
              <div className="select-all-divider"></div>
              <div className="add-user-sidebar-list">
              {filteredNonBiUsers.length > 0 ? (
                filteredNonBiUsers.map((user, index) => (
                  <div
                    key={index}
                    className={`add-user-item ${selectedNonBiUsers.includes(user.name) ? "selected" : ""}`}
                    onClick={() => handleToggleUserSelection(user.name)}
                  >
                    <input
                      type="checkbox"
                      className="user-checkbox"
                      checked={selectedNonBiUsers.includes(user.name)}
                      onChange={() => handleToggleUserSelection(user.name)}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <img
                      alt=""
                      src={
                        user.image
                          ? url + user.image
                          : createImageFromInitials(
                              35,
                              user.employee_name,
                              getRandomColor(user.employee_name)
                            )
                      }
                      className="user-avatar"
                    />
                    <span className="user-name">{user.employee_name}</span>
                  </div>
                ))
              ) : (
                <div className="user-empty">No users found</div>
              )}
              </div>
            </>
          ) : (
            <div className="user-empty">No users available to add</div>
          )}
        </div>
        
      </Drawer>
      </div>
    </>
  );

  if (!localStorage.getItem("authenticated")) {
    return (
      <div>
        <Login />
      </div>
    );
  } else {
    return (
      <>
        <MainComponent
          maincontent={content}
          showTemplate={createNewBi}
          showError={true}
          showSelector={true}
          showButtons={false}
          breadcrumbParent={"Onboarding"}
          breadcrumbChild={"BI Details"}
          showFullScreen={true}
          // handleNext={SendData}
          // handleBackButton={handleBackButton}
        />
      </>
    );
  }
}

export default BIDetails;
